import Swiper, {Pagination, Lazy, Parallax, Autoplay, Navigation} from "swiper";
import 'swiper/css';

export default function frontpage() {
  Swiper.use([Pagination, Lazy, Parallax, Autoplay, Navigation]);
  const swiper = new Swiper('.frontpage-slider__swiper', {
    speed: 800,
    loop: true,
     // autoplay: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    preloadImages: true,
    lazy: {
      loadPrevNext: true,
    },
    pagination: {
      el: ".frontpage-slider__pagination",
      clickable: true
    },
    parallax: true,
    navigation: {

      nextEl: '.frontpage-slider__nav--next',
      prevEl: '.frontpage-slider__nav--prev',
    },
    // parallax: true,
    // breakpoints: {
    //     0 : {
    //         parallax: false,
    //     },
    //     768: {
    //         parallax: true,
    //     }
    // }

  });
}
